"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgentDialogueLoader = AgentDialogueLoader;
exports.AgentLoadingLoader = AgentLoadingLoader;
exports.AgentUploadLoading = AgentUploadLoading;
exports.DescLoader = DescLoader;
exports.DialogueLoader = DialogueLoader;
exports.ListLoader = ListLoader;
exports.Loader = Loader;
var _react = _interopRequireDefault(require("react"));
var _loading_gray_slow = _interopRequireDefault(require("../../assets/animation/loading_gray_slow.gif"));
var _loading_gray = _interopRequireDefault(require("../../assets/animation/loading_gray.gif"));
var _loading_orange = _interopRequireDefault(require("../../assets/animation/loading_orange.gif"));
var _loading_orange_small = _interopRequireDefault(require("../../assets/animation/loading_orange_small.gif"));
var _loading_orange_middle = _interopRequireDefault(require("../../assets/animation/loading_orange_middle.gif"));
var _loading_circle = _interopRequireDefault(require("../../assets/images/loading_circle.svg"));
var _getPrefixCls = require("../../utils/getPrefixCls");
function Loader() {
  var styleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var loaderData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _loading_gray.default;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styleName
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: loaderData
  }));
}
function ListLoader() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-list-loader'), _loading_orange.default);
}
function DescLoader() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-desc-loader'));
}
function DialogueLoader() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-dialogue-loader'), _loading_gray_slow.default);
}
function AgentLoadingLoader() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-agent-loading-loader'), _loading_orange_small.default);
}
function AgentDialogueLoader() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-agent-dialogue-loader'), _loading_orange_middle.default);
}
function AgentUploadLoading() {
  return Loader((0, _getPrefixCls.getPrefixCls)('sp-agent-upload-loader'), _loading_circle.default);
}